/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SettingTokenTimeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('SETTING_TOKEN_TIME')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class SettingTokenTimeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SettingTokenTimeSettingParser.decode(input).map(res => new SettingTokenTimeSetting(res));
    }
    static unsafeDecode(input) {
        return SettingTokenTimeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SettingTokenTimeSettingParser.encode(data);
    }
    static schema() {
        return SettingTokenTimeSettingParser.schema();
    }
}
